import { useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledMultipleAutocomplete } from 'components/common/controller-wrapper'
import { useGetBidsPerJobAnalysisServiceCodesQuery } from 'generated/graphql'

import { BidsPerJobAnalysisFilterValues } from './BidsPerJobAnalysisFilterCriteria'
import { useBidsPerJobAnalysisQueryInput } from './useBidsPerJobAnalysisQueryInput'

export const BidsPerJobAnalysisServiceCodeMultipleAutocomplete = () => {
  const { control } = useFormContext<BidsPerJobAnalysisFilterValues>()
  const { start, end } = useBidsPerJobAnalysisQueryInput()

  const { data } = useGetBidsPerJobAnalysisServiceCodesQuery({
    variables: { input: { start, end } },
    skip: start == null || end == null,
  })

  const serviceCodes = useMemo(
    () =>
      [...(data?.bidsPerJobAnalysisServiceCodes ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((code) => ({ value: code.id, label: code.name })),
    [data],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name='selectedServiceCodes'
      label='Service code'
      options={serviceCodes}
      defaultValue={[]}
      limitTags={3}
      size='small'
      sx={{ minWidth: 220 }}
      noOptionsText='No service codes available in the selected period'
    />
  )
}
